import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from '@mui/material'
import axios from 'axios'
import { FormDataSubmission, ParentType } from 'chezy-inventory-backend/bin/types/CreateInventoryRequest'
import { useCallback, useContext, useState } from 'react'

import { AuthContext } from '../../utils/authContext'
import { getBaseURL } from '../../utils/getBaseURL'

export const CreateNewInventory = (props: { isOpen?: boolean; onDismiss?: () => void }) => {
  const authContext = useContext(AuthContext)
  const [parentInventory, setParentInventory] = useState<ParentType>({ mode: 'main' })
  const [importUnscanned, setImportUnscanned] = useState(false)
  const [importConditions, setImportConditions] = useState(false)
  const [importQuantities, setImportQuantities] = useState(false)
  const [eventId, setEventId] = useState('')
  const [eventName, setEventName] = useState('')
  const [eventPasskey, setEventPasskey] = useState('Chezy!')

  const onSubmit = useCallback(
    (data: FormDataSubmission) => {
      axios
        .post(`${getBaseURL()}/inventories`, data)
        .then(({ data }) => {
          authContext.reloadUserData()
          props.onDismiss?.()
        })
        .catch(({ data }) => {
          console.error(data)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.onDismiss, authContext]
  )

  return (
    <Dialog open={!!props.isOpen} onClose={props.onDismiss} fullWidth>
      <form
        onSubmit={(ev) => {
          ev.preventDefault()
          onSubmit({
            parent: parentInventory,
            importConditions,
            importQuantities,
            importUnscanned,
            id: eventId,
            name: eventName,
            passkey: eventPasskey,
          })
        }}
      >
        <DialogTitle>Create a new Inventory</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: 10 }}>
            <InputLabel id="parent-inv-id">Parent Inventory</InputLabel>
            <Select
              labelId="parent-inv-id"
              value={JSON.stringify(parentInventory)}
              label="Parent Inventory"
              onChange={(ev) => setParentInventory(JSON.parse(ev.target.value))}
            >
              <MenuItem value={JSON.stringify({ mode: 'main' })}>Main inventory (no parent event)</MenuItem>
              <MenuItem value={JSON.stringify({ mode: 'empty' })}>Blank inventory (no items included)</MenuItem>
              {authContext.permittedInventores.map((inv) => (
                <MenuItem key={inv.id} value={JSON.stringify({ mode: 'inv', invId: inv.id })}>
                  {inv.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormGroup>
            <FormControlLabel
              control={<Switch value={importUnscanned} onChange={(ev) => setImportUnscanned(ev.target.checked)} />}
              label="Copy unscanned items from parent inventory"
              disabled={parentInventory.mode !== 'inv'}
            />
            <FormControlLabel
              control={<Switch value={importConditions} onChange={(ev) => setImportConditions(ev.target.checked)} />}
              label="Copy conditions entered from previous inventory"
              disabled={parentInventory.mode !== 'inv'}
            />
            <FormControlLabel
              control={<Switch value={importQuantities} onChange={(ev) => setImportQuantities(ev.target.checked)} />}
              label="Pre-populate quantities (not recommended)"
              disabled={parentInventory.mode !== 'inv'}
            />
          </FormGroup>
          <TextField
            value={eventId}
            onChange={(ev) => setEventId(ev.target.value)}
            label="Event ID"
            required
            style={{ marginTop: 10 }}
            fullWidth
          />
          <TextField
            value={eventName}
            onChange={(ev) => setEventName(ev.target.value)}
            label="Event Name"
            required
            style={{ marginTop: 10 }}
            fullWidth
          />
          <TextField
            value={eventPasskey}
            onChange={(ev) => setEventPasskey(ev.target.value)}
            label="Event Passkey"
            required
            style={{ marginTop: 10 }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={props.onDismiss}>
            Cancel
          </Button>
          <Button type="submit">Save</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
